import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  userPersonnelInfos: [],
  allUserPersonnelInfos: [],
  totalPages: 0,
  totalRecords: 0,
  userPersonnelInfo: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_107: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_UserPersonnelInfos(state, userPersonnelInfos) {
    state.userPersonnelInfos = userPersonnelInfos.items;
    state.totalPages = userPersonnelInfos.totalPages;
    state.totalRecords = userPersonnelInfos?.totalRecords ?? 0;
  },
  SET_AllUserPersonnelInfos(state, userPersonnelInfos) {
    state.allUserPersonnelInfos = userPersonnelInfos;
  },
  SET_UserPersonnelInfo(state, userPersonnelInfo) {
    state.userPersonnelInfo = userPersonnelInfo;
  },
};
const actions = {
  errorUserPersonnelInfo({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllUserPersonnelInfos({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/UserPersonnelInfos/All?UserId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllUserPersonnelInfos', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserPersonnelInfo', error);
      });
  },
  getUserPersonnelInfosWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, cityId },
  ) {
    var url =
      '/UserPersonnelInfos/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_UserPersonnelInfos', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserPersonnelInfo', error);
      });
  },
  addUserPersonnelInfo({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/UserPersonnelInfos', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserPersonnelInfo', error);
      });
  },
  getUserPersonnelInfo({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/UserPersonnelInfos/ById?userPersonnelInfoId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_UserPersonnelInfo', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserPersonnelInfo', error);
      });
  },
  editUserPersonnelInfo({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/UserPersonnelInfos/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserPersonnelInfo', error);
      });
  },
  deleteUserPersonnelInfo({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/UserPersonnelInfos/Remove?userPersonnelInfoId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserPersonnelInfo', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
